import styles from './SelectPaymentMethod.module.scss';
import formStyles from 'legacy/common/components/form/Form.module.scss';

import { useState } from 'react';
import classnames from 'classnames';
import { AiFillCreditCard } from 'react-icons/ai';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { Card } from 'legacy/common/types/models';
import FadeIn from 'legacy/common/components/transition/FadeIn';

type SelectPaymentMethodProps = {
  cards: Card[];
  selectedCardId: string;
  onSelect: (cardId: string) => void;
  addCard: (options?: { onSuccess?: (cardId: string) => void }) => void;
};

const SelectPaymentMethod: React.FC<SelectPaymentMethodProps> = ({
  cards,
  selectedCardId,
  onSelect,
  addCard
}) => {
  const [newSelectedCard, setNewSelectedCard] = useState(selectedCardId || '');

  return (
    <FadeIn>
      <div className={styles.title}>Select Credit Card</div>

      <div className={styles.selectCreditCardWrapper}>
        {cards?.map((card) => (
          <div
            key={card._id}
            className={classnames(styles.card, {
              [styles.active]: card._id === newSelectedCard
            })}
            onClick={() => {
              setNewSelectedCard(card._id);
            }}
          >
            <div className={styles.cardNumberWrapper}>
              <AiFillCreditCard size="20px" />
              <span className={styles.cardNumber}>
                **** **** **** {card.last4}
              </span>
            </div>
          </div>
        ))}

        <div className={styles.selectButton}>
          <Button
            type={ButtonType.Primary}
            onClick={() => {
              onSelect(newSelectedCard);
            }}
          >
            Confirm
          </Button>
        </div>
      </div>

      {cards.length < 3 && (
        <>
          <div className={formStyles.separator}>
            <span />
            <div>OR</div>
            <span />
          </div>

          <div className={styles.selectButton}>
            <Button
              onClick={() =>
                addCard({
                  onSuccess: (cardId) => {
                    setNewSelectedCard(cardId);
                  }
                })
              }
            >
              + Add Another Card
            </Button>
          </div>
        </>
      )}
    </FadeIn>
  );
};

export default SelectPaymentMethod;
